var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 792.001 792.001",
    xmlSpace: "preserve",
    fill: "#9699AE",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M526.599,603.244L420.918,708.628V83.353l105.681,105.384c9.725,9.7,25.511,9.7,35.235,0 c9.724-9.699,9.724-25.437,0-35.136L414.855,7.067C409.659,1.896,402.78-0.306,396,0.04c-6.804-0.371-13.683,1.831-18.879,7.027 L230.167,153.6c-9.724,9.7-9.724,25.437,0,35.137c9.725,9.699,25.511,9.699,35.235,0L371.083,83.353v625.275L265.402,603.244 c-9.724-9.699-25.511-9.699-35.235,0c-9.724,9.7-9.724,25.437,0,35.137l146.954,146.558c5.196,5.171,12.075,7.373,18.855,7.027 c6.805,0.346,13.684-1.856,18.855-7.027l146.953-146.558c9.725-9.7,9.725-25.437,0-35.137 C552.085,593.545,536.323,593.545,526.599,603.244z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/doubleArrow.251a85930144855a08d51ac67efb435e.svg";
export { ForwardRef as ReactComponent };